import { useEffect } from "react";
import { getUserExternalDirectoryId } from "accelerator-aad/lib/getUserExternalDirectoryId";
import { getUserTimeZone } from "owa-session-store";

import { clearPlacesPeopleCacheIfTimezoneChanged } from "../utils/clearPlacesPeopleCacheIfTimezoneChanged";

/**
 * Runs one-shot maintenance on the places people cache: if the timezone the cache was
 * stored under differs from the current session timezone, the stale cache is cleared and
 * the timezone settings are re-synced.
 *
 * This runs in a `useEffect` (not inside a `useLiveQuery` querier) so the Dexie writes
 * happen in a normal readwrite transaction instead of the read-only liveQuery context.
 *
 * The owner and timezone are in the effect deps so maintenance re-runs when the account
 * or timezone changes even if the surface stays mounted (no unmount/remount).
 */
export function usePlacesPeopleCacheMaintenance(): void {
    const currentOwner = getUserExternalDirectoryId();
    const currentTimeZone = getUserTimeZone();
    
    useEffect(() => {
        void clearPlacesPeopleCacheIfTimezoneChanged(currentOwner, currentTimeZone);
    }, [currentOwner, currentTimeZone]);
}
